/**
 * @generated SignedSource<<c7e4becee96dafbc5a8a9c40e43c203a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateSSOAPIKeysInput = {
  enabled: boolean;
};
export type UpdateSSOAPIKeysMutation$variables = {
  input: UpdateSSOAPIKeysInput;
};
export type UpdateSSOAPIKeysMutation$data = {
  readonly updateSSOAPIKeys: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly ssoAPIKeys: boolean | null | undefined;
  };
};
export type UpdateSSOAPIKeysMutation = {
  response: UpdateSSOAPIKeysMutation$data;
  variables: UpdateSSOAPIKeysMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ssoAPIKeys",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateSSOAPIKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateSSOAPIKeysPayload",
        "kind": "LinkedField",
        "name": "updateSSOAPIKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateSSOAPIKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateSSOAPIKeysPayload",
        "kind": "LinkedField",
        "name": "updateSSOAPIKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7e40a470e034b16f76652d3b9b22fb73",
    "id": null,
    "metadata": {},
    "name": "UpdateSSOAPIKeysMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateSSOAPIKeysMutation(\n  $input: UpdateSSOAPIKeysInput!\n) {\n  updateSSOAPIKeys(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    ssoAPIKeys\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2c9557f48b1f0daa22a44f2ab04ecfa";

export default node;
